import { Directive, computed, inject, input, output } from "@angular/core";

import { NotificationType } from "../../../apis/networkdashboard/graphql/graphql";
import { PAGE_TAB_CONFIG_DEFAULT, TabConfig } from "../../../components/subscription-detail/page-tab/tab-config";
import { SubscriptionDetailTab } from "../../../components/subscription-detail/page-tab/tab-types";
import { AuthService } from "../../../services/authservice";
import { MinimalSubscription } from "../types";

@Directive()
export class SubscriptionViewBase<S extends MinimalSubscription> {
  readonly #auth = inject(AuthService);

  subscription = input.required<S>();
  activities = input.required<NotificationType[]>();
  activeTab = input<SubscriptionDetailTab | undefined>(undefined);
  tabConfig = input<TabConfig<SubscriptionDetailTab>[]>(PAGE_TAB_CONFIG_DEFAULT);
  tabChange = output<SubscriptionDetailTab>();

  protected owner = computed(() => this.subscription().organisation);
  protected description = computed(() => this.subscription().description);
  protected customerDescription = computed(() => this.subscription().customerDescription);
  protected customerId = computed(() => this.subscription().customerId);
  protected isCurrentOrganisation = computed(() => this.#auth.isCurrentOrganisation(this.customerId()));
  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected status = computed(() => this.subscription().status);
  protected isTerminated = computed(() => this.status() === "terminated");
  protected isDirty = computed(() => this.subscription().dirty);
  protected startDate = computed(() => this.subscription().startDate);
  protected endDate = computed(() => this.subscription().endDate);
  protected references = computed(() => this.subscription().references);
  protected hasReferences = computed(() => this.references().length > 0);
  protected productName = computed(() => this.subscription().product.name);
  protected productTag = computed(() => this.subscription().product.tag);
  protected isConfigTabActive = computed(() => this.activeTab() === SubscriptionDetailTab.CONFIG);
  protected isGraphicViewTabActive = computed(() => this.activeTab() === SubscriptionDetailTab.GRAPHIC_VIEW);
}
